import PropertyNotes from '@/services/Rest/PropertyNotes';

export default {
	state: {
		notes: {}
	},
	actions: {
		fetchNotes({ commit, dispatch }, propertyId) {
			return PropertyNotes.getNotes(propertyId).then(response => {
				commit('setNotes', response.data.notes);
				return Promise.resolve(response);
			});
		},
		updateNote({ commit, dispatch }, note) {
			return PropertyNotes.updateNote(note);
		},
		deleteNote({ commit, dispatch }, data) {
			return PropertyNotes.deleteNote(data);
		}
	},
	mutations: {
		setNotes(state, data) {
			state.notes = data;
		}
	},
	getters: {
		getNotes(state) {
			return state.notes;
		}
	}
};
